export function formatDate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  let o = {
    "M+": date.getMonth() + 1,
    "d+": date.getDate(),
    "h+": date.getHours(),
    "m+": date.getMinutes(),
    "s+": date.getSeconds()
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + "";
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? str : padLeftZero(str)
      );
    }
  }
  function padLeftZero(str) {
    return ("00" + str).substr(str.length);
  }
  return fmt;
}

export function hasClass(el, className) {
  let reg = new RegExp("(^|\\s)" + className + "(\\s|$)");
  return el ? reg.test(el.className) : null;
}

export function addClass(el, className) {
  if (hasClass(el, className)) {
    return;
  }
  let newClass = el.className.split(" ");
  newClass.push(className);
  el.className = newClass.join(" ");
}

export function removeClass(el, className) {
  if (!hasClass(el, className)) {
    return;
  }
  let reg = new RegExp("(^|\\s)" + className + "(\\s|$)", "g");
  el.className = el.className.replace(reg, " ");
}

/**
 * 滚动动画
 * @param date //时间
 * @param el //滚动元素
 * @param direction //滚动方向 x y
 * @param number //滚动位置
 * @param time //滚动时间
 */
export function scrollAnimate(el, direction = "y", number = 0, time = 200) {
  // el滚动元素
  // direction滚动方向 x y
  // number滚动位置
  // time滚动时间
  if (!time) {
    if (direction == "y") {
      el.scrollTop = number;
    } else if (direction == "x") {
      el.scrollLeft = number;
    }
    return number;
  }
  const spacingTime = 20; // 设置循环的间隔时间  值越小消耗性能越高
  let spacingInex = time / spacingTime; // 计算循环的次数
  let nowPosi = 0; // 获取当前滚动条位置
  if (direction == "y") {
    nowPosi = el.scrollTop;
  } else if (direction == "x") {
    nowPosi = el.scrollLeft;
  }
  const everPosi = (number - nowPosi) / spacingInex; // 计算每次滑动的距离
  const scrollTimer = setInterval(() => {
    if (spacingInex > 0) {
      spacingInex--;
      scrollAnimate(el, direction, (nowPosi += everPosi), 0);
    } else {
      clearInterval(scrollTimer); // 清除计时器
    }
  }, spacingTime);
}
